import React from 'react'
import { Link } from 'react-router-dom'
import NoData from '../ui/NoData'
import "../ui/Styles.css"

function User({ users, error }) {
    return (
        <div className="container">
            <div>
                {
                    users.length === 0 && error ? <NoData /> : (users.length > 0) ? <h3 className="search-count">{users.length} Results found!</h3> : null
                }
            </div>
            <div className="grid__user">
                {
                    users.map(user => {
                        return (
                            <div className="user" key={user.id}>
                                <div className="img-overlay">
                                    <img className="profile img" src={user.avatar_url} alt="loading..." />
                                </div>
                                <h2 className="name">{user.login}</h2>
                                <Link to={`/users/${user.login}`} className="btn">More</Link>
                            </div>
                        )
                    })
                }

            </div>
        </div>
    )
}

export default User